<template>
  <div class="auth-methods" ref="container" v-resize="asidePosition">
    <div class="auth-methods__transition-wrapper">
      <transition-group :ref="'leftWrapper'" name="fade" mode="out-in" tag="div">
        <email-login v-if="!authType" @changeAuthType="changeAuthType" @authenticated="authenticated" key="tr1" />
        <!-- <phone-login v-else-if="authType === 'phone'"key="tr1" /> -->
        <playphone-login v-else-if="authType === 'playphone'" @authenticated="authenticated" key="tr2" />
        <playphone-last-step-login v-else-if="authType === 'playphone-last-step'" @authenticated="authenticated" key="tr3" />
        <forgot-password v-else-if="authType === 'forgot'" key="tr4" />
        <reset-password v-else-if="authType === 'reset'" @changeAuthType="changeAuthType" key="tr5" />
        <HelperBg v-if="showKim()" class="card card--rounded" id="forgot_bg" key="tr6" />
      </transition-group>
      <transition name="fade">
        <aside v-if="!showKim()" :style="`height: ${aside.height}; margin-top: ${aside.margin}`">
          <figure id="resized" class="card card--rounded hide-mobile" />
          <div class="card card--rounded">
            <p>{{ $t('auth.email.signUp.message') }}</p>
            <btn @click.prevent="goToSignUp" flat>{{ $t('auth.email.signUp.CTA') }}</btn>
          </div>
        </aside>
        <aside v-else :style="`height: ${aside.height}; margin-top: ${aside.margin}`">
          <Kim id="resized" mood="neutral" color="#B9008D" class="card card--rounded" />
        </aside>
      </transition>
    </div>
  </div>
</template>

<script>
import resize from 'vue-resize-directive'

export default {
  name: 'auth-methods',
  props: {
    params: Object,
    authType: String
  },
  directives: {
    resize
  },
  data() {
    return {
      aside: {
        height: 0,
        margin: 0
      }
    }
  },
  methods: {
    changeAuthType(type, parameters) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.$emit('changeAuthType', type, parameters)
    },
    authenticated() {
      this.$emit('authenticated')
    },
    showKim () {
      return this.authType === 'forgot'
    },
    goToSignUp () {
      this.$router.push({ name: 'signup', params: { ...this.$route.params }, query: { ...this.$route.query } })
    },
    enter(el) {
      // this.$refs.container.style.height = `${el.scrollHeight + 30}px`
      this.asidePosition()
    },
    asidePosition() {
      const formNode = document.getElementsByTagName('form')[0]
      const forgotBg = document.querySelector('#forgot_bg')
      if (formNode && document.getElementById('resized').clientHeight > 0) {
        formNode.parentNode.style.position = 'relative'
        let height = formNode.clientHeight + 'px'
        if (forgotBg) {
          height = `calc(${formNode.clientHeight + forgotBg.clientHeight}px + 3em)`
        }
        this.aside.height = height
        this.aside.margin = formNode.offsetTop + 'px'
      } else {
        this.aside.height = 'auto'
        this.aside.margin = '2rem'
      }
    }
  },
  mounted() {
    this.asidePosition()
  }
}
</script>

<style lang="scss" scoped>
.hide-mobile {
  @media ($screen-xs) {
    display: none;
  }
}
.auth-methods {
  height: 100%;
  transition: height 0.2s ease-in-out;
  transition-delay: 0.2s;
  width: 100%;
  margin: 0 auto;
  .helper-bg {
    height: 200px;
    padding: 0;
    margin: 1rem 0 0 0;
    border: 1rem solid #B9E857;
  }
  .kim {
    height: calc(100% + 2rem);
    display: none;
    @media ( $screen-md ) {
      display: block;
    }
  }

  @media ( $screen-md ) {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
  }

  &__transition-wrapper {
    text-align: left;
    @media ( $screen-md ) {
      display: flex;
    }
    & > div, aside {
      @include slide-transition;
      @media ( $screen-md ) {
        width: 50%;
        margin: 0 0.5rem;
      }
    }
    @media ( $screen-lg ) {
      >div {
        width: 55%;
      }
      >aside {
        width: 45%;
      }
      margin: 0 1rem;
    }
    aside {
      margin-top: 2rem;
      display: flex;
      flex-direction: column;
      transition: all 200ms;
      p {
        text-align: center;
        margin: 0 0 2rem;
        font-weight: 300;
      }
      .btn {
        width: 100%;
      }
      figure#resized:not(.kim) {
        margin: 0 0 1rem;
        width: 100%;
        height: 100%;
        border: 1rem solid #B9E857;
        display: none;
        overflow: hidden;
        background: {
          image: url(~@/assets/backgrounds/lightning.svg);
          repeat: repeat;
          position: center center;
          color: #B9E857; // green
        }
        &.--surpress {
          border: 0;
          padding: 0;
        }
        @media ( $screen-md ) {
          display: flex;
        }
      }
    }
  }
}
</style>
